var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-dialog-container"},[_c('v-progress-circular',{attrs:{"size":140,"width":7,"color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }